import type { FieldValidationError } from "@/shared/types/workflow/workflow-form.types";
import type { RichText, TextAreaField } from "@spz/shared-domain";
import { RichTextUtils } from "@spz/shared-domain";
import type { TFunction } from "i18next";

/**
 * Validates a textarea field according to its validation constraints
 */
export function validateTextArea({
  field,
  value,
  t,
}: {
  field: TextAreaField;
  value: RichText;
  t: TFunction;
}): FieldValidationError | undefined {
  if (!field.validation) {
    return undefined;
  }

  const textContent = RichTextUtils.getTextContent(value as RichText);

  if (
    field.validation.min_length &&
    textContent.length < field.validation.min_length
  ) {
    const min = field.validation.min_length;
    return {
      translationKey: "workflow_validation_min_length",
      type: "minLength",
      params: { count: min },
      message: t("workflow_validation_min_length", { count: min }),
    };
  }

  if (
    field.validation.max_length &&
    textContent.length > field.validation.max_length
  ) {
    const max = field.validation.max_length;
    return {
      translationKey: "workflow_validation_max_length",
      type: "maxLength",
      params: { count: max },
      message: t("workflow_validation_max_length", { count: max }),
    };
  }

  return undefined;
}
